// A free-text Enter can produce a name-only result instead of a selected Place.
export function getSelectedAddress(place: any): string | null {
  if (!place?.place_id || !Array.isArray(place.address_components) ||
      !place.address_components.length || typeof place.formatted_address !== 'string' ||
      !place.formatted_address.trim()) return null;
  const address = place.formatted_address.trim();
  const zipCode = place.address_components.find(component =>
    component.types?.includes('postal_code'))?.long_name || '';
  return zipCode && !address.includes(zipCode) ? `${address}, ${zipCode}` : address;
}
